import pino from 'pino';

export function createLogger(initialState) {
  return pino({ level: initialState.venomEnv === 'prod' ? 'error' : 'debug' });
}
